// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"32b7c699","732":"08e02aba","977":"038c2b37"}[chunkId] + ".chunk.js";
};